import React, { useCallback, useState, useEffect} from 'react';
import { ImageDropzone, FileUploadButton } from 'react-file-utils';
import { Box, Button } from '@mui/material';
import {
  ChatAutoComplete,
  UploadsPreview,
  useChannelStateContext,
  useMessageInputContext,
  QuotedMessagePreview,
  useChannelActionContext
} from 'stream-chat-react';
import { TypingIndicator } from '../TypingIndicator';
import { SendButton } from '../../assets';
import './MessageInput.css';

export const MessageInput = () => {
  const [curQuickReply, setCurQuickReply] = useState(null);
  const { channel, acceptedFiles, maxNumberOfFiles, multipleUploads, quotedMessage } = useChannelStateContext();
  const { addNotification, sendMessage } = useChannelActionContext();
  const messageInput = useMessageInputContext();
  const quickReplies = [
    { msg: 'Got it, thanks!', msgBtn: 'Got it, thanks!'},
    { msg: 'Good to go!', msgBtn: 'Good to go!'},
    { msg: 'Please, check in as Force Trans.', msgBtn: 'Please check in'},
    { msg: 'Location update, please.', msgBtn: 'Location update, please.'},
    { msg: 'Checking on it.', msgBtn: 'Checking on it.'},
    { msg: 'When and where will you be available?', msgBtn: 'When and where..?'}
  ];
  useEffect(() => {
    if (messageInput.text.startsWith('/')) messageInput.setText(messageInput.text.replace(/^\//, ''))
  }, [messageInput]);
  const onChange = useCallback( (e) => messageInput.handleChange(e), [messageInput]);
  const onSubmitMsg = (e) => {
    e.preventDefault();
    if (channel.type === 'prime' && messageInput.text.length > 1500) addNotification(`The message you are trying to send is larger than 1500 characters`, 'error');
    else if (channel.type !== 'prime' && messageInput.text.length > 5000) addNotification(`The message you are trying to send is larger than 5000 characters`, 'error');
    else messageInput.handleSubmit(e);
  };
  const onClickQuickReply = async (e, index) => {
    e.preventDefault();
    if (channel.type === 'prime' && e.type === 'click' && curQuickReply === index) {
      await sendMessage({text: quickReplies[index]['msg']});
      setCurQuickReply(null);
    }
    else setCurQuickReply(index);
  };
  const handleUploadFiles = (files) => {
    const maxFileSize = 20000000;
    let filesToUpload = files.filter(file => file.size <= maxFileSize);
    let filesToDiscard = files.filter(file => file.size > maxFileSize).map(file => file.name);
    if (filesToDiscard.length > 0) addNotification(`${maxFileSize/1000/1000} MB file size limit exceeded: ${filesToDiscard.join(', ').toLowerCase()}`, 'error');
    return messageInput.uploadNewFiles(filesToUpload);
  };
  return (
    <div className={`team-message-input__wrapper`}>
      {typeof quotedMessage === 'object' && <QuotedMessagePreview quotedMessage={quotedMessage}/>}
      <UploadsPreview />
      <ImageDropzone
        accept={acceptedFiles}
        handleFiles={(e) => handleUploadFiles(e)}
        maxNumberOfFiles={maxNumberOfFiles}
        multiple={multipleUploads}
        disabled={messageInput.maxFilesLeft === 0 ? true : false}
        >
        <div className='team-message-input__input'>
          <div className='team-message-input__top'>
            <ChatAutoComplete onChange={onChange} placeholder={`Send a message...`} handleSubmit={onSubmitMsg} />
            <div className='team-message-input__button' role='button' aria-roledescription='button' onClick={onSubmitMsg}>
              <SendButton />
            </div>
          </div>
          <Box className='team-message-input__bottom' sx={{overflowX: 'auto'}}>
            <Box className='team-message-input__icons'>
              <FileUploadButton handleFiles={handleUploadFiles} multiple={true} accept={acceptedFiles} disabled={messageInput.maxFilesLeft === 0 ? true : false}/>
              <Box className='icon-divider'></Box>
            </Box>
            <Box sx={{display: 'flex', flexGrow: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly'}}>
              {channel.type === 'prime' && quickReplies.map((qReply, index) =>
                <Button key={index} variant="text" size="medium" sx={{ color: curQuickReply === index ? '#009AC9' : 'grey', '&:hover': {color: '#009AC9'}, ml: 1, fontSize: '0.7rem'}} disableRipple={true}>
                  <Box component="span" sx={{textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', display: 'block'}} onClick={(e) => onClickQuickReply(e, index)}>{curQuickReply === index ? qReply.msg : qReply.msgBtn.substring(0,24)}</Box>
                </Button>)}
            </Box>
          </Box>
        </div>
      </ImageDropzone>
      <TypingIndicator type='input' />
    </div>
  );
};
